import { DataSource, Image, Layout } from "@mcleod/components";

export abstract class AutogenLayoutEdiStopShowAsButton extends Layout {
	imageShowAs: Image;
	sourceEdiStop: DataSource;
}